import { CARD_COMBOS, cloneRange } from './combos';
/**
 * Zero every combo that contains one of `dead` and record those indices in `removed`.
 * Idempotent and order-independent; merges with any pre-existing `removed` set.
 */
export const applyRemoval = (r, dead) => {
    const out = cloneRange(r);
    const removedSet = new Set(out.removed);
    for (const c of dead) {
        for (const idx of CARD_COMBOS[c]) {
            // Only combos that were actually in the range are "zeroed by dead cards" - a combo that was
            // never in range (weight 0) carries no display meaning, so it isn't recorded.
            if (out.weights[idx] > 0)
                removedSet.add(idx);
            out.weights[idx] = 0;
        }
    }
    out.removed = Uint16Array.from([...removedSet].sort((a, b) => a - b));
    return out;
};
//# sourceMappingURL=removal.js.map